const en = {
  // Header
  'header.nav.home': 'Home',
  'header.nav.order': 'Order',
  'header.nav.menu': 'Menu',
  'header.nav.booking': 'Book a table',
  'header.nav.book': 'Booking',
  'header.nav.gallery': 'Gallery',
  'header.nav.reviews': 'Reviews',
  'header.nav.contact': 'Contact',
  'header.nav.changeTheme': 'Change Theme',
  'header.nav.changeLanguage': 'Change Language',
  'header.nav.offlineMenus': 'Offline Menus',

  // Home
  'home.orderNow': 'Order online now',
  'home.preorderMenu': 'CLOSED - Pre-order now!',
  'home.order': 'Order now',
  'home.preorder': 'Preorder',
  'home.viewMenu': 'View menu',

  'home.specialOffer': 'Special offer',
  'home.ourFood.title': 'Our Food',
  'home.aboutUs.title': 'About Us',
  'home.open': 'Open',
  'home.closed': 'Closed',
  'home.openForPreorder': 'CLOSED',
  'home.restaurant.fullOpeningTime': 'full opening hours and contact details',
  'home.restaurant.openNext': 'Open next: ',
  'home.restaurant.openOn': 'Open on ',

  'home.getInTouch.title': 'Get in Touch',
  'home.getInTouch.openingTime': 'Opening times and contact details',
  'home.getInTouch.bookATable': 'Book a table',

  // Contact page
  'contact.address': 'Address',
  'contact.openInGoogleMaps': '(Open in Google Maps)',
  'contact.contactDetails': 'Contact Details',
  'contact.tel': 'Phone',
  'contact.email': 'Email',
  'contact.pickupHours': 'Pickup Hours',
  'contact.deliveryHours': 'Delivery Hours',
  'contact.deliveryArea': 'Delivery Area',
  'contact.deliveryAreaNote': '*Refer to the map below for our delivery area:',
  'contact.closedDays': 'Closed Days',
  'contact.openDays': 'Special Operating Hours',

  // MENU
  'menu.restaurantClosedMessage': 'Sorry - online ordering is temporarily unavailable',

  // Gallery
  'gallery.subTitle': 'Some of our most popular dishes',
  'gallery.orderNow': 'Order Now',
  'gallery.deals': 'Our Takeaway Deals',

  // Footer
  'footer.viewMenu': 'view menu',
  'footer.termsAndConditions': 'terms & conditions',
  'footer.sitemap': 'sitemap',
  'footer.poweredBy': 'Powered by',

  // Basket
  'basket.addToBasket': 'Add +',
  'basket.more': 'More',
  'basket.total': 'Total',
  'basket.subtotal': 'Sub Total',
  'basket.deliveryFee': 'Delivery Fee',
  'basket.orderAdminFee': 'Service Charge',
  'basket.placeOrder': 'Checkout',
  'basket.collection': 'Collection',
  'basket.delivery': 'Delivery',

  'basket.forDelivery': 'for delivery',
  'basket.forDeliveryAndCollection': 'for delivery / collection',
  'basket.forCollection': 'for collection',
  'basket.forPreOrder': 'to pre-order',
  'basket.deliveryPreorderOnly': 'Delivery pre-order only',
  'basket.collectionPreorderOnly': 'Collection pre-order only',
  'basket.forDeliveryAndPreorderCollection': 'for delivery / collection pre-order',
  'basket.forCollectionAndPreorderDelivery': 'for collection / delivery pre-order',
  'basket.forPreorderCollection': 'for collection pre-order',
  'basket.forPreorderDelivery': 'for delivery pre-order',
  'basket.deliveryNotAvailable': 'Delivery not available',
  'basket.collectionNotAvailable': 'Collection not available',
  'basket.eta': '{eta} mins',

  'basket.yourOrder': 'Your order',
  'basket.specialInstructions': 'Any special instructions?',
  'basket.typeHere': 'Type here...',
  'basket.emptyBasket': 'Your basket is empty.',
  'basket.weAreClosedTitle': 'Sorry, we\'re closed!',
  'basket.weAreClosedFromTo': 'We are closed from {fromDate} to {toDate}',
  'basket.weAreClosedL1': 'We open {nextOpeningTimeDay} at {nextOpeningTimeTime}',
  'basket.weAreClosedL2': 'Check our {link}.',
  'basket.weAreClosedOpeningHours': 'opening hours',
  'basket.totalDeliveryNote': 'Don\'t worry, you\'ll get to check your order on the next page before finalising',
  'basket.deliveryMinimum': 'Minimum delivery amount',
  'basket.changeOrder': 'Click here to change your order.',
  'basket.changeOrderMobile': 'Change your order',
  'basket.close': 'Close',
  'basket.cancel': 'Cancel',

  // Meal
  'meal.photo.failed': 'Failed to load image',
  'meal.free': 'FREE',

  // Form
  'form.addressLine1.required': 'Please enter your address',
  'form.city.required': 'Please enter your city',
  'form.postcode.required': 'Please enter your postcode',
  'form.name.required': 'Please enter your name',
  'form.email.required': 'Please enter your email address',
  'form.phone.required': 'Please enter your contact number',
  'form.paymentType.required': 'Please set a payment type',
  'form.required': 'Required',

  // Checkout
  'checkout.myOrder': 'My order is for',
  'checkout.collection': 'Collection',
  'checkout.delivery': 'Delivery',
  'checkout.deliveryAddress': 'Delivery Address',
  'checkout.deliveryAddressLine1': 'Address',
  'checkout.deliveryAddressLine2': 'Address Line 2',
  'checkout.deliveryAddressCity': 'City',
  'checkout.deliveryAddressPostcode': 'Postcode',
  'checkout.pleaseClickHere': 'please click here',
  'checkout.consumerName': 'Name',
  'checkout.consumerEmail': 'Email',
  'checkout.consumerInvalidEmailError': 'Please enter a valid email',
  'checkout.consumerEmailNote': 'to confirm your order',
  'checkout.consumerPhone': 'Contact Number',
  'checkout.consumerInvalidPhoneError': 'Please enter a valid contact number',
  'checkout.consumerPhoneNote': 'in case we need to call you',
  'checkout.minimumLengthError': 'Please enter a valid address',
  'checkout.futureOrderDay': 'Day required',
  'checkout.futureOrderTime': 'Time required',
  'checkout.comment': 'Optional Meal Requests',
  'checkout.subscribe': 'Subscribe to receive deals',
  'checkout.byEmail': 'by email',
  'checkout.byText': 'by text message',
  'checkout.subscribeInfo': 'We will never give your details to anyone else and we\'ll only be in touch occasionally.',
  'checkout.cookieParagraph': 'This website uses cookies in order to save your details for future orders.',
  'checkout.voucher': 'Got a voucher code? Click here...',
  'checkout.voucherModalTitle': 'Enter your voucher code',
  'checkout.voucherModalSubmitButton': 'Submit voucher code',
  'checkout.voucherModalTryAgain': 'Try again',
  'checkout.voucherModalCancelButton': 'Cancel',
  'checkout.voucherModalCloseButton': 'Close',
  'checkout.voucherError.voucher_not_found': 'Sorry, your voucher code is not recognised.',
  'checkout.voucherError.promotion_not_enabled': 'Sorry, your voucher code is not active.',
  'checkout.voucherError.invalid_day_of_week': 'Sorry, your voucher is not valid on this day of the week.',
  'checkout.voucherError.invalid_fulfillment_method_type': 'Sorry, this voucher is only for {value} orders.',
  'checkout.voucherError.max_usage_reached': 'Sorry, your voucher code has expired.',
  'checkout.voucherError.invalid_time_window': 'Sorry, your voucher code has expired.',
  'checkout.voucherError.total_spent_not_met': 'Sorry, your order total is below the minimum required for this voucher code.',
  'checkout.voucherError.multiple_discount_not_allowed': 'Thanks for your voucher code. Only 1 discount is allowed per order so we have kept the larger one in your basket.',
  'checkout.voucherAccepted': 'Congratulations, your voucher code {value} has been accepted!',
  'checkout.allergy': 'Allergy and dietary information',
  'checkout.allergyModalTitle': 'Allergies and ingredients in our dishes',
  'checkout.allergyModalDescriptionP1': 'We try to ensure that the information on this site is accurate at all times and makes clear the presence of common food allergens. However, from time to time the chefs may make changes as they prepare our dishes so the ingredients of each dish cannot be guaranteed.',
  'checkout.allergyModalDescriptionP2': 'Please use the special request or comments box to specify particular allergies or dietary requirements.',
  'checkout.allergyModalDescriptionP3': 'If you are in any doubt about the presence of allergens, the ingredients of a particular dish or any other dietary information, please contact the restaurant directly before ordering.',
  'checkout.allergyModalButton': 'Ok',
  'checkout.paymentByCreditCardButton': 'Pay By Credit card',
  'checkout.paymentByPayPalButton': 'Pay With PayPal',
  'checkout.paymentOnDeliveryButton': 'Pay On Delivery',
  'checkout.paymentOnCollectionButton': 'Pay On Collection',
  'checkout.paymentCompleteOrderButton': 'Complete order',
  'checkout.paymentOptions': 'Payment Options',
  'checkout.paymentTypeCreditCard': 'Credit or Debit Card',
  'checkout.paymentTypeCreditCard.JJ': 'Pay Online',
  'checkout.paymentTypePayPal': 'PayPal',
  'checkout.paymentTypeCash': 'Cash on ',
  'checkout.paymentTypeCash.JJ': 'Card on ',
  'checkout.paymentDisclaimer': 'Please note all payments will show up from ‘FOODit Limited’ and by submitting this order you acknowledge that you accept our {link}.',
  'checkout.termsAndConditions': 'terms and conditions',
  'checkout.invalidDateError': 'invalid date or time',
  'checkout.cannotAcceptOrdersError': 'restaurant cannot accept orders',
  'checkout.deliveryMinimumAmountErrorLine1': 'You need to spend {price} more to meet the minimum delivery amount of {minimumAmount}.',
  'checkout.deliveryMinimumAmountErrorLine2': 'If you would like to change your order, {link}.',
  'checkout.deliveryErrorOutOfRange': 'Sorry, your address is outside our delivery area. If you would like to collect your order from us instead {link}',
  'checkout.deliveryErrorPostcodeNotFound': 'Postcode not found',
  'checkout.deliveryFee': 'You will be charged {price} for delivery to this address.',
  'checkout.restaurantClosedModalDescriptionL1': 'Sorry, we have now closed.',
  'checkout.restaurantClosedModalDescriptionL2': 'Please click {link} for our opening times.',
  'checkout.here': 'here',
  'checkout.clickHere': 'please click here',
  'checkout.checkInvalidData': 'Please scroll up and correct any errors or missing details',
  'checkout.websiteBy': 'Website by',
  'checkout.poweredBy': 'Powered by',
  'checkout.troubleOrdering': 'Trouble ordering?',
  'checkout.reportAnError': 'Report an error',
  'checkoutErrorModal.close': 'Close',
  'checkoutErrorModal.title': 'Please correct the following errors or missing details',
  'checkoutErrorReportModal.close': 'Close',
  'checkoutErrorReportModal.send': 'Send error report',
  'checkoutErrorReportModal.title': 'Report an error',
  'checkoutErrorReportModal.title.thankyou': 'Thank you for reporting an error',
  'checkoutErrorReportModal.thankyou': 'We have received your error report, we are looking into the issue, in the meantime, please call the restaurant to order',
  'checkoutErrorReportModal.callRestaurant': 'Call restaurant ({phone})',

  'confirmation.yourOrderAsap': 'Your order has been sent to {restaurantName} and is awaiting confirmation.',
  'confirmation.yourOrderFutureTime': 'We will prepare your order to be ready on {fulfillAt}.',
  'confirmation.discount': 'Discount {discount}%',
  'confirmation.voucherDiscountFixed': 'Voucher Discount',
  'confirmation.voucherDiscountPercentage': 'Voucher Discount {discount}%',
  'confirmation.ordered': 'Thanks for your order!',
  'confirmation.orderedInfo': 'We\'ve sent you an email with your order details and order number. As soon as the kitchen begins your order we\'ll update you here and by email with their estimated completion time.',
  'confirmation.orderedFutureInfo': 'Once confirmed we will prepare it to be ready for {time}',
  'confirmation.confirm': 'We have confirmed your order!',
  'confirmation.confirmInfo': 'We started preparing your meal at {time}. It will be ready in about {eta} minutes.',
  'confirmation.futureOrderInfo': 'We will prepare your order to be ready for {time}.',
  'confirmation.cancel': 'Sorry, Your order has been cancelled!',
  'confirmation.cancelInfo': 'Please call the restaurant on {tel} if you need further information.',
  'confirmation.ready': 'Your order is ready',
  'confirmation.readyForDelivery': 'Your order is on it\'s way to you',
  'confirmation.readyForCollection': 'Your order is ready to collect',
  'confirmation.completed': 'Your order is completed',
  'confirmation.completedInfo': 'We hope you enjoy your meal and look forward to feeding you again soon!',
  'confirmation.orderSummaryTitle': 'Your Details',
  'confirmation.ordered.info': 'Order received',
  'confirmation.confirm.info': 'Order confirmed',
  'confirmation.preparing.info': 'Preparing your order',
  'confirmation.readyForCollection.info': 'Ready to collect',
  'confirmation.readyForDelivery.info': 'On its way to you',
  'confirmation.summary.delivery': 'Delivery',
  'confirmation.summary.orderAdminFee': 'Service Charge',
  'confirmation.summary.total': 'Total',

  'modal.iosPrivateMode': 'Before you place an order we recommend turning Safari\'s private browsing off - it can sometimes stop the checkout from working properly',
  'modal.ok': 'OK',
  'modal.close': 'Close',

  'notFound.info1': 'Oops, looks like something is wrong!',
  'notFound.info2': 'Hungry? You might be looking for the {menu} or visit our {homepage}',
  'notFound.menu': 'MENU',
  'notFound.homepage': 'HOMEPAGE',

  'newsletterUnsubscribe.thankYou': 'Thank you, you have been unsubscribed from our marketing emails.',
  'newsletterSubscribe.thankYou': 'Thank you, you are now subscribed to our emails.',
  'newsletterUnsubscribe.kingRegards': 'Kind Regards, {restaurantName}',
  'newsletterSubOrUnsubscribe.errorMessage': 'Please email {foodit} to let us know',
  'newsletterUnsubscribe.error': 'Error during unsubscribe',
  'newsletterSubscribe.error': 'Error during subscribe',

  'error.refresh': 'Oops, something went wrong. Please click OK to refresh.',
  'error.item.refresh': 'Sorry, one or more items in your basket have changed price or are no longer available. Please click OK to refresh your basket',
  'error.payment': 'Sorry, there was a problem with your payment. Please try again or select a different payment type.',

  'thirdParty.facebook.like': 'Facebook',
  'thirdParty.facebook.getDeals': 'Like us on {link} to get all our latest deals.',

  'booking.title': 'Book a table',
  'booking.subTitle': 'Make a table booking request for {name}',
  'booking.name': 'Name',
  'booking.phone': 'Phone number',
  'booking.email': 'Email',
  'booking.guests': 'Number of guests',
  'booking.date': 'Date',
  'booking.time': 'Time',
  'booking.bookTable': 'Book table',
  'booking.requestSent': 'Your table booking request has been sent!',
  'booking.confirmation1': 'You will receive a confirmation email once we have checked availability.',
  'booking.confirmation2': 'If we cannot accommodate your request we will get in touch to discuss alternatives.',
  'booking.exceedLimit': 'The maximum number of guests for this reservation is {max}',

  // Reviews
  'reviews.title': 'Reviews',
  'reviews.tripAdvisor': 'TripAdvisor',
  'reviews.tripAdvisorError': 'Failed to load reviews from TripAdvisor',

  // Under Maintenance
  'underMaintenance.title': 'Under Maintenance',
  'underMaintenance.text': 'Sorry, this website is undergoing maintenance or has been permanently disabled.',

  // Meal disabled modal
  'disabledMealModal.text': 'Sorry, this meal is only available on {mealAvailableDays}.',

  // Upselling
  'upSelling.title': 'Last chance to add these!',
  'upSelling.cancel': 'Cancel',
  'upSelling.checkout': 'Continue to checkout',

  // Feedback
  'feedback.title': 'Thanks for ordering from {name}',
  'feedback.subtitle': 'Help others find their perfect dish by telling us what you liked or didn’t like about your recent order.',
  'feedback.order.delivery': 'Was your order delivered on time? ({minEta}-{maxEta} mins)',
  'feedback.order.collection': 'Was your order ready on time? ({minEta}-{maxEta} mins)',
  'feedback.comments': 'Additional comments',
  'feedback.orderAgain': 'Would you order this dish again?',
  'feedback.likeMost': 'What did you like most about this dish?',
  'feedback.unlikeMost': 'What do you feel could be improved about this dish?',
  'feedback.upToThree': '(up to 3)',
  'feedback.anymore': 'Any other observations about the dish?',
  'feedback.thanks': 'Thanks for sharing your thoughts with us!',
  'feedback.fulfillmentError': 'Please tell us about the service and food you received.',

  'button.orderNow': 'Order Now',

  'footer.copyright': 'Copyright © {year}'
};

export default en;



// WEBPACK FOOTER //
// ./locale/en.js